// TODO: Move this JS file to Webpack folder since it is now only consumed by
// Webpacker-compiled applications
import 'angular';
import { select, selectAll } from 'd3-selection';
import { arc, pie } from 'd3-shape';
import { scaleLinear } from 'd3-scale';
import '../../../services/chart.service';
import '../common/chart-label';
import '../common/chart-legend';
import '../common/empty-results';

angular.module('directives.visualizations.pieChart', ['services.ChartService'])
  .directive('pieChart', [
    'ChartService',
    function(Chart) {
      return {
        restrict: 'E',
        scope: {
          items: '=',
          emptyMessage: '=?',
          colorRange: '<',
          onClickCallback: '=',
          innerRadius: '<'
        },

        template:
          '<empty-results ng-hide="items.length" message="emptyMessage"></empty-results>' +
          '<div class="row">' +
            '<div class="col-sm-8">' +
              '<div class="chart" ng-class="{\'animated\': animated}">' +
                '<chart-label position="label.position" visibility="label.visible" key="label.key" value="label.value" arrow="label.arrow"></chart-label>' +
                '<svg></svg>' +
              '</div>' +
            '</div>' +
            '<div class="col-sm-4">' +
              '<chart-legend mouseover="mouseover" mouseout="mouseout" click="onClickCallback" data="items" color="color"></chart-legend>' +
            '</div>' +
          '</div>',

        link: function (scope, element) {
          // Container (to get the SVG tag and the size to center the chart)
          var container = element[0].querySelector('.chart');
          // SVG element, used to clean the chart
          var target = container.querySelector('svg');
          // D3 element, used to draw the chart and find slices
          var svg = select(target);
          // Radius of the pie chart
          var radius;
          // Processed data (min, max, total, sorted)
          var data;

          scope.label = {
            arrow: true,
            position: {}
          };

          // Flag to animate the chart when is being centered
          scope.animated = false;

          /**
           * Function to get the path size for a slice depending on the
           * specified radius
           *
           * @param {number} radius - Radius size
           * @returns {object}       - D3 path object
           */
          var getPath = function(aktiveRadius) {
            return arc()
              .outerRadius(aktiveRadius)
              .innerRadius(scope.innerRadius || 0);
          };

          /**
           * Function to be executed on mouseover events, it increases the size
           * of a specified slice (path), applies a class to the legend and
           * fills the label object (and displays it)
           *
           * @param {string} key - Slice/Legend value key
           * @returns {undefined}
           */
          scope.mouseover = function(key) {
            var slice = svg.select('[data-id="' + key + '"]');
            // Slice binded data
            var datum = slice.datum();

            // Slice resize
            slice.selectAll('path').attr('d', getPath(radius));

            // Legend highlight
            selectAll('.chart-legend [data-id="' + key + '"]')
              .classed('active', true);

            // Label properties
            var area = arc()
              .outerRadius(radius - radius * 0.25)
              .innerRadius(radius - radius * 0.25);
            var position = area.centroid(datum);

            var size = Chart.getSize(container);
            var y = (size.height - radius * 2) / 2;
            var x = (size.width - radius * 2) / 2;

            scope.label.visible = true;
            scope.label.key = datum.data.key;
            scope.label.value = devex.util.numberWithCommas(datum.value) + ' (' +
                                (datum.value / data.total * 100).toFixed(1) + '%)';
            scope.label.position.top = position[1] + radius + y;
            scope.label.position.left = position[0] + radius + x;
          };

          /**
           * Function to be executed on mouseout events, it reduces the size
           * of a specified slice (path), removes a class of the legend and
           * hides the label
           *
           * @param {string} key - Slice/Legend value key
           * @returns {undefined}
           */
          scope.mouseout = function(key) {
            var slice = svg.select('[data-id="' + key + '"]');

            // Slice resize
            slice.selectAll('path').attr('d', getPath(radius - 10));

            // Legend highlight
            selectAll('.chart-legend [data-id="' + key + '"]')
              .classed('active', false);

            // Label properties
            scope.label.visible = false;
          };

          /**
           * Function to center the chart in it's container depending on the
           * container's size
           *
           * @param {boolean} animated - Wether the chart should be centered
           * with an animation or not
           * @returns {undefined}
           */
          var centerChart = function(animated) {
            if(animated) {
              scope.animated = true;
            }

            var size = Chart.getSize(container);

            var width = size.width / 2;
            var height = size.height / 2;
            var chart = 'translate(' + width + ', ' + height + ')';
            target.querySelector('.pie').setAttribute('transform', chart);

            window.setTimeout(function() {
              scope.animated = false;
            }, 1000);
          };

          var render = function() {
            // First we erase the content rendered on the SVG element
            Chart.erase(target);

            /**
             * DATA
             */
            data = Chart.getData(scope.items);

            /**
             * SIZE
             */
            var size = Chart.getSize(container);

            var width = size.width / 2;
            var height = size.height / 2;
            radius = height > width ? width : height;

            /**
             * STYLING
             */
            scope.color = scaleLinear()
              .domain([data.min, data.max])
              .range(scope.colorRange ? scope.colorRange : ['#BBCCDD', '#336699']);

            /**
             * CHART
             */
            var chart = svg.append('g').attr('class', 'pie');

            var pieShape = pie()
              .value(({value}) => value);

            centerChart();

            /**
             * PIE SLICES
             */
            // Slice group
            var slice = chart.selectAll('.slice')
              .data(pieShape(data.value_sorted))
              .enter()
              .append('g')
              .attr('class', 'slice')
              .attr('data-id', function(d) {
                return d.data.key;
              })
              .on('mouseover', function(_, d) {
                scope.$apply(function() {
                  scope.mouseover(d.data.key);
                });
              })
              .on('mouseout', function(_, d) {
                scope.$apply(function() {
                  scope.mouseout(d.data.key);
                });
              })
              .on('click', function(_, d) {
                scope.$apply(function() {
                  if (scope.onClickCallback){
                    scope.onClickCallback(d.data.key);
                  }
                });
              });

            // Slice part
            slice.append('path')
              .attr('d', getPath(radius - 10))
              .attr('fill', function(d) {
                return scope.color(d.data.value);
              });
          };

          var renderWithData = function() {
            if(scope.items && scope.items.length) {
              render();
            }
          };

          renderWithData();

          scope.$watch('items', renderWithData);

          window.addEventListener('resize', renderWithData);

          scope.$on('$destroy', function() {
            window.removeEventListener('resize', renderWithData);
          });
        }
      };
    }
  ]);
